import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const WhatsappIconOutlined: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <g clipPath="url(#clip0_3711_200473)">
                <path
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M18.07 14.66c-.07-.12-.27-.2-.56-.34-.29-.14-1.74-.85-2-.95-.26-.1-.47-.15-.66.15-.19.3-.5.73-.67.92-.17.19-.34.22-.64.07a9.2 9.2 0 01-4.14-3.58c-.17-.29 0-.45.13-.59.49-.49.5-.42.62-.66a.53.53 0 000-.51C10 9 9.45 7.58 9.2 7c-.25-.58-1.51-.69-2-.15C2 12.33 14.67 21.72 17.91 16a1.41 1.41 0 00.16-1.32M12 .75A11.22 11.22 0 00.74 11.91a11 11 0 002.14 6.54l-1.4 4.15 4.32-1.37a11.26 11.26 0 0017.44-9.32A11.22 11.22 0 0012 .75z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_3711_200473">
                    <path fill="#fff" d="M0 0H24V24H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(WhatsappIconOutlined);
